import React from 'react';

import CardHOC from './Components/CardHOC';
import Choice from '../../../Types/Components/Choice';

const ChoiceType = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <Choice question={question} />
  </CardHOC>
}

export default ChoiceType;